import Vue from 'vue'
import Router from 'vue-router'

// import manager from '../views/manager.vue'//主页面

const manager = () =>
    import ('../views/manager.vue'); //主页面


// import login from '../views/login.vue'//登录页面
const login = () =>
    import ('../views/login.vue'); //登录页面
// import register from '../views/register.vue'//注册页面
const register = () =>
    import ('../views/register.vue'); //注册页面


const verifying = () =>
    import ('../views/verifying.vue'); //正在审核页面

// import home from '../views/HomePage/HomePage.vue'//首页
const home = () =>
    import ('../views/HomePage/HomePage.vue'); //首页
// import changePWD from '../views/HomePage/changePWD.vue'//修改密码
const changePWD = () =>
    import ('../views/HomePage/changePWD.vue'); //修改密码
// import feedBack from '../views/HomePage/feedBack.vue'//反馈
const feedBack = () =>
    import ('../views/HomePage/feedBack.vue'); //反馈
// import message from '../views/HomePage/message.vue'//消息
const message = () =>
    import ('../views/HomePage/message.vue'); //消息



// 店铺设置

// import shopInfo from '../views/ShopSet/shopInfo.vue'//店铺信息主页面
const shopInfo = () =>
    import ('../views/ShopSet/shopInfo.vue'); //店铺信息主页面
// import expenditureDetail from '../views/ShopSet/expenditureDetail.vue'//余额支出明细
const expenditureDetail = () =>
    import ('../views/ShopSet/expenditureDetail.vue'); //余额支出明细
// import authentication from '../views/ShopSet/Authentication.vue'//店铺信息-认证
const authentication = () =>
    import ('../views/ShopSet/Authentication.vue'); //店铺信息-认证
// import addShop from '../views/ShopSet/addShop.vue'//店铺信息-新增商铺
const addShop = () =>
    import ('../views/ShopSet/addShop.vue'); //店铺信息-新增商铺

// 商品管理
// import goodControl from '../views/GoodPage/goodControl.vue'//商品管理-库存管理
const goodControl = () =>
    import ('../views/GoodPage/goodControl.vue'); //商品管理-库存管理
// import addGood from '../views/GoodPage/addGood.vue'//商品管理-添加商品
const addGood = () =>
    import ('../views/GoodPage/addGood.vue'); //商品管理-添加商品
// import addSaleOrder from '../views/GoodPage/addSaleOrder.vue'//商品管理-添加销售订单
const addSaleOrder = () =>
    import ('../views/GoodPage/addSaleOrder.vue'); //商品管理-添加销售订单
// import allGoodControl from '../views/GoodPage/allGoodControl.vue'//商品管理-全网库存
const allGoodControl = () =>
    import ('../views/GoodPage/allGoodControl.vue'); //商品管理-全网库存

// 订单管理
// import orderControl from '../views/orderControl/orderControl.vue'//平台订单
const orderControl = () =>
    import ('../views/orderControl/orderControl.vue'); //平台订单
// import shopOrderControl from '../views/orderControl/shopOrderControl.vue'//门店订单
const shopOrderControl = () =>
    import ('../views/orderControl/shopOrderControl.vue'); //门店订单
const onlineOrder = () =>
  import ('../views/orderControl/onlineOrder.vue'); //线上订单

// 员工管理
// import staffAccountControl from '../views/staffControl/staffAccountControl.vue'//员工账号管理
const staffAccountControl = () =>
    import ('../views/staffControl/staffAccountControl.vue'); //员工账号管理
// import addStaff from '../views/staffControl/addStaff.vue'//添加账号
const addStaff = () =>
    import ('../views/staffControl/addStaff.vue'); //添加账号
// import powerControl from '../views/staffControl/powerControl.vue'//权限设置
const powerControl = () =>
    import ('../views/staffControl/powerControl.vue'); //权限设置

// 客户管理
// import myCustomer from '../views/CustomerControl/myCustomer.vue'//我的客户管理
const myCustomer = () =>
    import ('../views/CustomerControl/myCustomer.vue'); //我的客户管理
// import addCustomer from '../views/CustomerControl/addCustomer.vue'//新增客户
const addCustomer = () =>
    import ('../views/CustomerControl/addCustomer.vue'); //新增客户

// 护理管理
// import addGuard from '../views/ProtectionManagement/AddGuard.vue'//护理管理-添加护理单
const addGuard = () =>
    import ('../views/ProtectionManagement/AddGuard.vue'); //护理管理-添加护理单
// import workOrder from '../views/ProtectionManagement/WorkOrder.vue'//护理管理-护理订单
const workOrder = () =>
    import ('../views/ProtectionManagement/WorkOrder.vue'); //护理管理-护理订单

// 结算管理
// import goodSettlement from '../views/SettlementControl/GoodSettlement.vue'//结算管理-商品结算
const goodSettlement = () =>
    import ('../views/SettlementControl/GoodSettlement.vue'); //结算管理-商品结算
// import settlementDetails from '../views/SettlementControl/SettlementDetails.vue'//结算管理-商品结算
const settlementDetails = () =>
    import ('../views/SettlementControl/SettlementDetails.vue'); //结算管理-商品结算

//财务报表
// import financialStatements from '../views/Financial/FinancialStatements.vue'//财务报表
const financialStatements = () =>
    import ('../views/Financial/FinancialStatements.vue'); //财务报表

// 营销管理
// import microshopWebsite from '../views/MarketingManagement/MicroshopWebsite.vue'//营销管理-微店网站
const microshopWebsite = () =>
    import ('../views/MarketingManagement/MicroshopWebsite.vue'); //营销管理-微店网站
// import addScan from '../views/MarketingManagement/AddScan.vue'//营销管理-添加二维码
const addScan = () =>
    import ('../views/MarketingManagement/AddScan.vue'); //营销管理-添加二维码
// import marketingAnalysis from '../views/MarketingManagement/MarketingAnalysis.vue'//营销管理-营销分析
const marketingAnalysis = () =>
    import ('../views/MarketingManagement/MarketingAnalysis.vue'); //营销管理-营销分析
// import microshopScan from '../views/MarketingManagement/MicroshopScan.vue'//营销管理-微店二维码
const microshopScan = () =>
    import ('../views/MarketingManagement/MicroshopScan.vue'); //营销管理-微店二维码

//知识体系
// import articleManagement from '../views/KnowledgeSystem/ArticleManagement.vue'//知识体系-文章
const articleManagement = () =>
    import ('../views/KnowledgeSystem/ArticleManagement.vue'); //知识体系-文章
// import editors from '../views/KnowledgeSystem/Editors.vue'//知识体系-文章编辑
const editors = () =>
    import ('../views/KnowledgeSystem/Editors.vue'); //知识体系-文章编辑
// import payforKnowledge from '../views/KnowledgeSystem/PayforKnowledge.vue'//知识体系-知识付费
const payforKnowledge = () =>
    import ('../views/KnowledgeSystem/PayforKnowledge.vue'); //知识体系-知识付费

// 账户管理
// import addBankcard from '../views/AccountManagement/AddBankcard.vue'//账户管理-添加银行卡
const addBankcard = () =>
    import ('../views/AccountManagement/AddBankcard.vue'); //账户管理-添加银行卡
// import myWallet from '../views/AccountManagement/MyWallet.vue'//账户管理-我的钱包
const myWallet = () =>
    import ('../views/AccountManagement/MyWallet.vue'); //账户管理-我的钱包
// import platformIndex from '../views/AccountManagement/PlatformIndex.vue'//账户管理-平台指数
const platformIndex = () =>
    import ('../views/AccountManagement/PlatformIndex.vue'); //账户管理-平台指数
// import putForward from '../views/AccountManagement/PutForward.vue'//账户管理-提现
const putForward = () =>
    import ('../views/AccountManagement/PutForward.vue'); //账户管理-提现
// import recharge from '../views/AccountManagement/Recharge.vue'//账户管理-充值
const recharge = () =>
    import ('../views/AccountManagement/Recharge.vue'); //账户管理-充值
const merchantWithdraw = () =>
  import ('../views/AccountManagement/MerchantWithdraw'); //账户管理-提现申请

//商戶管理
const merchantList = () =>
  import('../views/BusinessManagement/MerchantList.vue'); //商戶管理-商戶实名认证

// import businessReg from '../views/bussinessReg.vue'; //企业注册
const businessReg = () =>
  import ('../views/BusinessManagement/businessReg.vue'); //企业注册

Vue.use(Router);

export default new Router({
    routes: [{
            path: '/login',
            name: 'login',
            component: login,
        },
        {
            path: '/register',
            name: 'register',
            component: register,
        },
        {
            path: '/verifying',
            name: 'verifying',
            component: verifying,
        },
        {
            path: '/',
            name: 'manager',
            redirect: '/home',
            component: manager,
            meta: [],
            children: [{
                    path: '/',
                    name: 'home',
                    component: home,
                    meta: [],
                },
                {
                    path: '/changePWD',
                    name: 'changePWD',
                    component: changePWD,
                    meta: [],
                },
                {
                    path: '/feedBack',
                    name: 'feedBack',
                    component: feedBack,
                    meta: [],
                },
                {
                    path: '/message',
                    name: 'message',
                    component: message,
                    meta: [],
                },
                // 店铺设置
                {
                    path: '/shopinfo',
                    name: 'shopInfo',
                    component: shopInfo,
                    meta: [{ name: '门店设置' }, { name: '门店信息' }],
                }, {
                    path: '/authentication',
                    name: 'authentication',
                    component: authentication,
                    meta: [{ name: '门店设置' }, { name: '门店信息', to: 'shopinfo' }, { name: '认证' }],
                }, {
                    path: '/expenditureDetail',
                    name: 'expenditureDetail',
                    component: expenditureDetail,
                    meta: [{ name: '门店设置' }, { name: '门店信息', to: 'shopinfo' }, { name: '余额支出明细' }],
                }, {
                    path: '/addShop',
                    name: 'addShop',
                    component: addShop,
                    meta: [{ name: '门店设置' }, { name: '门店信息', to: 'shopinfo' }, { name: '新增门店' }],

                },
                {
                    path: '/shoppowerControl',
                    name: 'powerControl',
                    component: powerControl,
                    meta: [{ name: '门店设置' }, { name: '权限设置' }],
                },

                // 商品管理
                {
                    path: '/goodControl',
                    name: 'goodControl',
                    component: goodControl,
                    meta: [{ name: '商品管理' }, { name: '库存管理' }],
                }, {
                    path: '/addGood',
                    name: 'addGood',
                    component: addGood,
                    meta: [{ name: '商品管理' }, { name: '添加商品' }],
                }, {
                    path: '/addSaleOrder',
                    name: 'addSaleOrder',
                    component: addSaleOrder,
                    meta: [{ name: '商品管理' }, { name: '库存管理', to: 'goodControl' }, { name: '添加销售订单' }],
                }, {
                    path: '/allGoodControl',
                    name: 'allGoodControl',
                    component: allGoodControl,
                    meta: [{ name: '商品管理' }, { name: '全网库存' }],
                },

                // 订单管理
                {
                    path: '/orderControl',
                    name: 'orderControl',
                    component: orderControl,
                    meta: [{ name: '订单管理' }, { name: '平台订单' }],
                }, {
                    path: '/shopOrderControl',
                    name: 'shopOrderControl',
                    component: shopOrderControl,
                    meta: [{ name: '订单管理' }, { name: '门店订单' }],
                },
              {
                path: '/onlineOrder',
                name: 'onlineOrder',
                component: onlineOrder,
                meta: [{ name: '订单管理' }, { name: '线上订单' }],
              },

                //员工管理
                {
                    path: '/staffAccountControl',
                    name: 'staffAccountControl',
                    component: staffAccountControl,
                    meta: [{ name: '员工管理' }, { name: '员工账号管理' }],
                }, {
                    path: '/powerControl',
                    name: 'powerControl',
                    component: powerControl,
                    meta: [{ name: '员工管理' }, { name: '员工账号管理', to: 'staffAccountControl' }, { name: '权限设置' }],
                }, {
                    path: '/addStaff',
                    name: 'addStaff',
                    component: addStaff,
                    meta: [{ name: '员工管理' }, { name: '员工账号管理', to: 'staffAccountControl' }, { name: '添加账户' }],
                },

                //客户管理
                {
                    path: '/myCustomer',
                    name: 'myCustomer',
                    component: myCustomer,
                    meta: [{ name: '客户管理' }, { name: '我的客户管理' }],
                }, {
                    path: '/clueControl',
                    name: 'clueControl',
                    component: marketingAnalysis,
                    meta: [{ name: '客户管理' }, { name: '线索管理' }],
                }, {
                    path: '/addCustomer',
                    name: 'addCustomer',
                    component: addCustomer,
                    meta: [{ name: '客户管理' }, { name: '我的客户管理', to: 'myCustomer' }, { name: '新增客户' }],
                },




                // 护理管理
                {
                    path: '/addGuard',
                    name: 'addGuard',
                    component: addGuard,
                    meta: [{ name: '护理管理' }, { name: '添加护理单' }],
                },
                {
                    path: '/workOrder',
                    name: 'workOrder',
                    component: workOrder,
                    meta: [{ name: '护理管理' }, { name: '护理订单', }],
                },

                // 结算管理
                {
                    path: '/goodSettlement',
                    name: 'goodSettlement',
                    component: goodSettlement,
                    meta: [{ name: '结算管理' }, { name: '商品结算' }],
                },
                {
                    path: '/settlementDetails',
                    name: 'settlementDetails',
                    component: settlementDetails,
                    meta: [{ name: '结算管理' }, { name: '商品结算', to: 'goodSettlement' }, { name: '结算明细' }],
                },


                //财务报表
                {
                    path: '/financialStatements',
                    name: 'financialStatements',
                    component: financialStatements,
                    meta: [{ name: '财务报表' }],
                },

                //营销管理
                {
                    path: '/microshopWebsite',
                    name: 'microshopWebsite',
                    component: microshopWebsite,
                    meta: [{ name: '营销管理' }, { name: '微店网站' }],
                }, {
                    path: '/marketingAnalysis',
                    name: 'marketingAnalysis',
                    component: marketingAnalysis,
                    meta: [{ name: '营销管理' }, { name: '营销分析' }],
                }, {
                    path: '/microshopScan',
                    name: 'microshopScan',
                    component: microshopScan,
                    meta: [{ name: '营销管理' }, { name: '微店二维码' }],
                }, {
                    path: '/addScan',
                    name: 'addScan',
                    component: addScan,
                    meta: [{ name: '营销管理' }, { name: '微店二维码', to: 'microshopScan' }, { name: '添加二维码' }],
                },
                //知识体系
                {
                    path: '/articleManagement',
                    name: 'articleManagement',
                    component: articleManagement,
                    meta: [{ name: '知识体系' }, { name: '文章' }],
                }, {
                    path: '/editors',
                    name: 'editors',
                    component: editors,
                    meta: [{ name: '知识体系' }],
                }, {
                    path: '/payforKnowledge',
                    name: 'payforKnowledge',
                    component: payforKnowledge,
                    meta: [{ name: '知识体系' }, { name: '知识付费' }],
                },


                //账户管理
                {
                  path: '/merchantWithdraw',
                  name: 'merchantWithdraw',
                  component: merchantWithdraw,
                  meta: [{ name: '账户管理' }, { name: '提现申请' }],
                },
                {
                    path: '/myWallet',
                    name: 'myWallet',
                    component: myWallet,
                    meta: [{ name: '账户管理' }, { name: '我的钱包' }],
                }, {
                    path: '/platformIndex',
                    name: 'platformIndex',
                    component: platformIndex,
                    meta: [{ name: '账户管理' }, { name: '平台指数' }],
                }, {
                    path: '/addBankcard',
                    name: 'addBankcard',
                    component: addBankcard,
                    meta: [{ name: '账户管理' }, { name: '我的钱包', to: 'myWallet' }, { name: '添加银行卡' }],
                }, {
                    path: '/putForward',
                    name: 'putForward',
                    component: putForward,
                    meta: [{ name: '账户管理' }, { name: '我的钱包', to: 'myWallet' }, { name: '提现' }],
                }, {
                    path: '/recharge',
                    name: 'recharge',
                    component: recharge,
                    meta: [{ name: '账户管理' }, { name: '我的钱包', to: 'myWallet' }, { name: '充值' }],
                },
              //商户管理
              {
                path:'/merchantList',
                name:'merchantList',
                component:merchantList,
                meta:[{name:'商户管理'},{name:'商户实名认证列表'}]
              },{
                path:'/businessReg',
                name:'businessReg',
                component:businessReg,
                meta:[{name:'商户管理'},{name:'商户实名认证列表',to:'merchantList'},{name:'商户实名认证'}]
}
            ]
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js